import React, { useContext, useEffect } from "react";
import "./style.css";
import { StatusMessageContext } from "lib/context/StatusMessageContext";

export default function StatusMessage() {
  const { message, setMessage } = useContext(StatusMessageContext);
  const { type } = useContext(StatusMessageContext);

  // Clear the message only when the component unmounts
  useEffect(() => {
    return () => setMessage("");
  }, []);

  if (!message) {
    return null;
  }

  return <div className={`validation validation--${type}`}>{message}</div>;
}
